module.exports = __webpack_public_path__ + "img/10@3x.b379117b.png";